module.exports = __webpack_public_path__ + "media/alarm1.ad30dde3.wav";